import React from "react";
import { string } from "prop-types";
import styled, { useTheme } from "styled-components";
import Heading from "../shared/Heading";
import Subheading from "../shared/Subheading";
import {
  desktop,
  font,
  fontSize,
  fontWeight,
  color,
} from "@components/shared/utils";

const TitleWrapper = styled.div`
  margin-top: 1rem;
  text-align: center;
  z-index: 10;
  padding: 0rem 2rem 1rem;
  text-align: left;

  ${desktop`
  margin-bottom: 0;
  padding: 1rem 2rem;
`}
`;

const StyledHeading = styled(Heading)`
  color: ${({ customColor }) => customColor};
  text-transform: uppercase;
  font-family: ${font("citroen")};
  font-size: ${fontSize("xl")};
  font-weight: ${fontWeight("bolder")};
  margin: 1rem 0;

  ${desktop`
  font-size: ${fontSize("xxl")};
`}
`;

const StyledSubheading = styled(Subheading)`
  color: ${color("black")};
  font-size: ${fontSize("md")};
  width: 75%;
  margin: 1rem 0 -2rem 0;

  ${desktop`
  width: 100%;
  margin: 0 auto;
`}
`;

const BookingMessage = ({ heading, subheading }) => {
  const theme = useTheme();

  return (
    <TitleWrapper>
      <StyledHeading customColor={theme.colors.testDriveDefault}>
        {heading}
      </StyledHeading>
      <StyledSubheading>{subheading}</StyledSubheading>
    </TitleWrapper>
  );
};

BookingMessage.propTypes = {
  heading: string.isRequired,
  subheading: string.isRequired,
};

export default BookingMessage;
